<template>
  <b-modal
    ref="addGanttModal"
    hide-footer
    centered
    :title="modalTitle"
    size="lg"
    @shown="shown = true"
    @hidden="$emit('hide')"
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-form @submit.prevent="save">
      <b-form-group
        label="Title:"
      >
        <b-form-input
          type="text"
          v-model.trim="$v.title.$model"
          :class="{ 'is-invalid': $v.title.$error }"
          :disabled="inProgress"
          autocomplete="off"
        />
        <b-form-invalid-feedback
          v-if="!$v.title.required"
        >
          The Title is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        label="Data source:"
      >
        <b-form-select
          v-model.trim="$v.dataSource.$model"
          @change="dataSourceChanged"
          :class="{ 'is-invalid': $v.dataSource.$error }"
          :disabled="inProgress"
          :options="dataSourceList"
        ></b-form-select>
        <b-form-invalid-feedback
          v-if="!$v.dataSource.required"
        >
          The DataSource is required
        </b-form-invalid-feedback>
      </b-form-group>
      <div v-if="dataSource">
        <b-form-group
          label="IDs storage:"
        >
          <b-form-select
            v-model.trim="$v.id.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.id.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.id.required"
          >
            IDs storage is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Desctiptions storage:"
        >
          <b-form-select
            v-model.trim="$v.description.$model"
            :options="dataGridCols"
            :class="{ 'is-invalid': $v.description.$error }"
            :disabled="inProgress"
          />
          <b-form-invalid-feedback
            v-if="!$v.description.required"
          >
            Descriptions storage is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Assigned to storage:"
        >
          <b-form-select
            v-model.trim="$v.assignedTo.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.assignedTo.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.assignedTo.required"
          >
            Assigned to storage is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Start Date storage:"
        >
          <b-form-select
            v-model.trim="$v.start.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.start.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.start.required"
          >
            Start date storage is required
          </b-form-invalid-feedback>
          <b-form-invalid-feedback
            v-if="!$v.start.typeValidate"
          >
            Start date must be a Date type
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Progress(%) storage:"
        >
          <b-form-select
            v-model.trim="$v.percent.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.percent.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.percent.required"
          >
            Progress storage is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Task type storage:"
        >
          <b-form-select
            v-model.trim="$v.type.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.type.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.percent.required"
          >
            Task type storage is required
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group
          label="Duration storage:"
        >
          <b-form-select
            v-model.trim="$v.duration.$model"
            :options="dataGridCols"
            :disabled="inProgress"
            :class="{ 'is-invalid': $v.duration.$error }"
          />
          <b-form-invalid-feedback
            v-if="!$v.duration.required"
          >
            Duration storage is required
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
      <b-button
        variant="success"
        type="submit"
      >
        Save
      </b-button>
    </b-form>
  </b-modal>
</template>

<script>
  import {mapState} from 'vuex'
  import {required, numeric} from 'vuelidate/lib/validators'
  // helpers
  import eventBus from '@/helpers/event-bus'
  // services
  import db from '@/services/db'

  let $ = window.$
  const typeValidate = (type) =>
    (value) => value.type === type

  export default {
    props: ['widgetsComputed', 'source', 'ganttId', 'cols'],
    data () {
      return {
        layout: 'b-card',
        inProgress: false,
        startSource: '',
        dataSource: '',
        title: '',
        id: '',
        description: '',
        assignedTo: '',
        start: '',
        type: '',
        percent: '',
        duration: '',
      }
    },
    computed: {
      ...mapState([
        'currentTab',
        'computedProps',
        'dataGrid_options'
      ]),
      modalTitle () {
        return 'Create Gantt Chart'
      },
      dataGridCols () {
        try {
          let cols = this.dataGrid_options[this.dataSource].meta
          let options = Object.keys(cols).map((el) => {
            return {
              value: {value: el, type: cols[el].type},
              text: el
            }
          })
          return options
        } catch (e) {
          return []
        }
      },
      dataSourceList () {
        try {
          const list = [
            ...Object.keys(this.dataGrid_options).map(el => {
              return {
                value: el,
                text: el
              }
            })
          ]
          return list
        } catch (e) {
          return []
        }
      }
    },
    methods: {
      open () {
        this.$refs.addGanttModal.show()
      },
      dataSourceChanged () {
        this.id = ''
        this.description = ''
        this.assignedTo = ''
        this.start = ''
        this.type = ''
        this.percent = ''
        this.duration = ''
      },
      save () {
        if (this.inProgress) return
        this.$v.$touch()
        if (this.$v.$invalid) return
        this.inProgress = true

        let data = {
          layout: 'b-card',
          title: this.title,
          id: this.id.value,
          label: this.description.value,
          user: this.assignedTo.value,
          start: this.start.value,
          type: this.type.value,
          percent: this.percent.value,
          duration: this.duration.value,
          dataGrid: this.dataSource,
        }
        this.$store.commit('addProcess', {
          process: 'addWidget',
          message: 'Creating'
        })
        db.gantt.saveOptions(this.ganttId, data, (key) => {
          if (this.$refs.addGanttModal) this.$refs.addGanttModal.hide()
          this.$store.commit('deleteProcess', 'addWidget')
          this.$store.commit('editWidget', {
            key,
            insert: true
          })
          this.inProgress = false
          this.$nextTick(() => {
            this.$v.$reset()
          })
        })
        this.$emit('updated', this.dataSource === this.startSource)
      }
    },
    validations: {
      title: {
        required
      },
      dataSource: {
        required
      },
      id: {
        required
      },
      description: {
        required
      },
      assignedTo: {
        required
      },
      start: {
        required,
        typeValidate: typeValidate('date')
      },
      type: {
        required
      },
      duration: {
        required
      },
      percent: {
        required
      }
    },
    created () {
      eventBus.$on('addGanttChart', (widgetType) => {
        if (this.$refs.addGanttModal) this.$refs.addGanttModal.show()
      })
    },
    mounted () {
      this.title = this.cols.title
      this.dataSource = this.source
      this.startSource = this.source
      try {
        this.id = this.dataGridCols.find(el => el.text === this.cols.id).value
        this.description = this.dataGridCols.find(el => el.text === this.cols.label).value
        this.assignedTo = this.dataGridCols.find(el => el.text === this.cols.user).value
        this.start = this.dataGridCols.find(el => el.text === this.cols.start).value
        this.type = this.dataGridCols.find(el => el.text === this.cols.type).value
        this.percent = this.dataGridCols.find(el => el.text === this.cols.percent).value
        this.duration = this.dataGridCols.find(el => el.text === this.cols.duration).value
      } catch (e) {
        console.log(e)
      }
    }
  }
</script>

<style lang="scss">
  @import '~$scss/globals';

  .templateEditor {
    height: 40vh;
    border: 1px solid $borderColor1;
  }

  .vue-codemirror {
    height: 100%;
  }

  .CodeMirror {
    height: 100%;
  }

  .gridstackSize {
    @include cf;

    &__item {
      @include span(6)

      &:first-child {
        padding-right: 10px;
      }

      &:last-child {
        padding-left: 20px;
      }

      @include breakpoint(max-width $screenSm) {
        @include span(12)
        &:first-child {
          padding-right: 0;
        }
        &:last-child {
          padding-left: 0;
        }
      }
    }
  }
</style>
